//NPM LIBRARIES
import React from 'react';
import PropTypes from 'prop-types';
//COMPONENTS AND UTILITIES
import CheckboxOption from '../CheckboxOption';
import { AUcallout } from '@gov.au/callout';
import RadioButtonGroup from '../RadioButtonGroup';
import { AUformGroup } from '@gov.au/form';

/* DEFAULT
 * The Declaration component
 *
 * @param  {string}  id                      - id 
 * @param  {string}  name                    - name
 * @param  {string}  label                   - label for checkbox
 * @param  {boolean}  status                 - status of the input
 * @param  {function}  returnCheckboxValues  - return function for answer
 * @param  {object}  children                - HTML content appearing in call out
 * @param  {string}  stepid                  - stepid
 * @param  {array}   initvalue               - initial value of input
 * @param  {boolean}  defaultChecked         - start of pre checked
 */
const Declaration = (props) => {
    return (
        <AUformGroup>
            <AUcallout
                title=""
                srOnlyTitle>
                <h3>Declaration</h3>
                {props.children}
                <p></p>
                <div>
                    <CheckboxOption
                        type="checkbox"
                        name={props.name}
                        id={props.id}
                        questionid={props.id}
                        stepid={props.stepid}
                        value='Declaration'
                        defaultChecked={props.defaultChecked}
                        optionLabel={props.label}
                        checked={props.checked}
                        status={props.status}
                        returnCheckboxValues={props.returnCheckboxValues} >
                    </CheckboxOption>
                </div>
            </AUcallout>
        </AUformGroup>
    );
}

Declaration.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    stepid: PropTypes.string.isRequired,
    initvalue: PropTypes.string,
    defaultChecked: PropTypes.bool,
    checked: PropTypes.bool,
    label: PropTypes.string,
    status: PropTypes.string,
    returnCheckboxValues: PropTypes.func,
    children: PropTypes.object
};

Declaration.defaultProps = {
    name: 'declaration'
};

export default Declaration;

/* 
 * The ConditionalDeclaration component
 *
 * @param  {object}  children   - HTML content appearing in call out
 */
export const ConditionalDeclaration = (props) => {
    return (
        <AUformGroup>
            <AUcallout
                title=""
                srOnlyTitle>
                <h3>Declaration</h3>
                {props.children}
                <p></p>
                <div>
                    <RadioButtonGroup {...props} />
                </div>
            </AUcallout>
        </AUformGroup>
    );
}

ConditionalDeclaration.propTypes = {
    children: PropTypes.object,
};